// Shared search-param parser for the Inbox routes (DEV-16229/30/32). Both
// `/inbox` and `/inbox/closed-signals` accept `?signal=<id>` to open
// the detail drawer; a single parser keeps both routes' inferred types in
// sync.
export interface IInboxSearch {
  signal?: string;
}

export function parseInboxSearch(raw: Record<string, unknown>): IInboxSearch {
  const signal = raw.signal;
  return {
    signal: typeof signal === 'string' && signal.length > 0 ? signal : undefined,
  };
}
